var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({'background-color':_vm.$store.getters.getColorPalette().backgroundColorCode}),attrs:{"fluid":""}},[_c('SafetyIncidentPanel')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }